module.exports = __webpack_public_path__ + "img/domain.f839ac04.svg";